/**
 * Parses a full name string into first and last name components
 * Handles various edge cases including multiple names, single names, and whitespace
 *
 * @param fullName - The full name string to parse
 * @returns Object with firstName and lastName strings
 */
export function parseFullName(fullName: string | null | undefined): {
  firstName: string
  lastName: string
} {
  // Handle null, undefined, or empty strings
  if (!fullName || typeof fullName !== 'string') {
    return { firstName: '', lastName: '' }
  }

  // Trim and split on whitespace, filtering out empty strings
  const nameParts = fullName.trim().split(/\s+/).filter(Boolean)

  if (nameParts.length === 0) {
    return { firstName: '', lastName: '' }
  }

  if (nameParts.length === 1) {
    return { firstName: nameParts[0], lastName: '' }
  }

  // First part is firstName, everything else becomes lastName
  const firstName = nameParts[0]
  const lastName = nameParts.slice(1).join(' ')

  return { firstName, lastName }
}
